var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclaimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFE7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2167 50L42.8833 26.6666C42.5926 26.1536 42.171 25.7269 41.6615 25.4301C41.1521 25.1332 40.573 24.9768 39.9833 24.9768C39.3937 24.9768 38.8146 25.1332 38.3051 25.4301C37.7957 25.7269 37.3741 26.1536 37.0833 26.6666L23.75 50C23.4561 50.5089 23.3021 51.0865 23.3034 51.6741C23.3047 52.2618 23.4613 52.8387 23.7574 53.3463C24.0535 53.854 24.4786 54.2743 24.9895 54.5647C25.5004 54.8551 26.079 55.0053 26.6667 55H53.3333C53.9182 54.9994 54.4926 54.8449 54.9988 54.5521C55.5051 54.2593 55.9254 53.8385 56.2175 53.3318C56.5097 52.8252 56.6634 52.2506 56.6633 51.6658C56.6631 51.0809 56.5091 50.5064 56.2167 50Z",
    stroke: "#003B6F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 35V41.6667",
    stroke: "#003B6F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48.3334H40.0167",
    stroke: "#003B6F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimation);
export default __webpack_public_path__ + "static/media/exclaimation.f9151b83f02796029b1a0102cebf2fec.svg";
export { ForwardRef as ReactComponent };